// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"40338fd8","146":"64fbad16","787":"d89296ed","844":"f1683b76","856":"b1d1ff97","990":"cc9899d1"}[chunkId] + ".chunk.js";
};